<template>
	<div ref="mainBody" class="mainBody" v-show="!isLoading">
		<van-sticky :offset-top="0">
			<div class="navbar bgDark">
				<div class="h100 dFlex alCenter jcBetween" style="max-width: 1280px;margin: 0 auto;">
					<div class="logo dFlex alCenter">
						<van-image
						  width="191px"
						  height="51px"
						  fit="cover"
						  :src="logo"
						/>
						<!-- <span class="ml-3">Pomelo Co., Limited</span> -->
					</div>
					<div class="navbarList">
						<ul class="dFlex alCenter">
							<li :class="{'active':current=='/home'}">
								<router-link to="/home">首页</router-link>
							</li>
							<li :class="{'active':current=='/about'}">
								<router-link to="/about">關於我們</router-link>
							</li>
							<li :class="{'active':current=='/contact'}">
								<router-link to="/contact">聯繫我們</router-link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</van-sticky>
		<AppMain />
		<div class="bgDark footers mt-5">
			<div class="pcMaxW secPadding">
				<van-row>
				  <van-col span="5">
					  <div style="font-size: 0;">
					  	<van-image
					  	  width="180px"
					  	  height="48px"
					  	  fit="cover"
					  	  :src="logo"
					  	/>
					  </div>
				  </van-col>
				  <van-col span="4">
					  <h4>PRODUCTS</h4>
					  <ul>
						  <li><router-link to="/about">About Us</router-link></li>
						  <li><router-link to="/home">Home</router-link></li>
					  </ul>
				  </van-col>
				  <van-col span="4">
					  <h4>SERVICES</h4>
					  <ul>
						  <li><router-link to="/about">Services</router-link></li>
						  <li><router-link to="/contact">Contact</router-link></li>
					  </ul>
				  </van-col>
				  <van-col span="4">
					  <h4>CONNECT</h4>
					  <ul>
						  <li><a href="https://api-v1.gamepomelo.com/html/Privacy.html">Privacy</a></li>
						  <li><router-link to="/contact">Support</router-link></li>
					  </ul>
				  </van-col>
				  <van-col span="7">
					  <h4>ABOUT US</h4>
					  <ul>
						  <li><a href="#">Pomelo Co., Limited</a></li>
						  <li><a href="#">Email：pomelocolimited@gmail.com</a></li>
						  <li><a href="#">Tel：+852 9736 3878</a></li>
						  <li><a href="#">Address：RM 101A, 1/F., GENPLAS IND BUILDING, 56 HOI YUEN ROAD,
							KWUN TONG
							HONG KONG</a></li>
					  </ul>
				  </van-col>
				</van-row>
			</div>
		</div>
		<div class="footer mt-3">
			<div class="pcMaxW dFlex jcBetween pt-4 pb-4">
				<p class="textWhite50">Copyright © Pomelo Co., Limited 2026</p>
				<div>
					<a href="/about" class="textSecondary">About Us</a>
					&nbsp; · &nbsp;
					<a href="https://api-v1.gamepomelo.com/html/Privacy.html" target="_blank" class="textSecondary">Privacy Policy</a>
					&nbsp; · &nbsp;
					<a href="#" class="textSecondary">Terms &amp; Conditions</a>
				</div>
			</div>
		</div>
	</div>
	<van-popup v-model:show="isLoading" round :style="{ padding: '20px' }">{{ $t('common.loading') }}</van-popup>
</template>

<script setup>
import { ref,reactive,inject,defineAsyncComponent,onMounted,getCurrentInstance,watch,computed } from 'vue'
import { useRoute,useRouter,onBeforeRouteUpdate } from 'vue-router'
import { useI18n } from "vue-i18n"

const AppMain = defineAsyncComponent(() => import("./components/AppMain.vue"));

const { proxy } = getCurrentInstance();

const route = useRoute();
const router = useRouter();
const current = ref(route.meta.activeMenu);
const isLoading = ref(false)
const logo = ref(require('@/assets/images/logo.png'))
onBeforeRouteUpdate((to) => {
	current.value = to.meta.activeMenu;
	console.log(current.value)
});

onMounted(()=>{
	
})

const { locale } = useI18n();
const changeLang = () => {
	let lang = locale.value == 'kr' ? 'zh' : 'kr';
	locale.value = lang;
	reload()
}

</script>

<style lang="less" scoped>
	.mainBody{
		width: 100%;
		.navbar{
			width: 100%;height: 80px;padding: 15px 0;
			.logo{
				img{
					vertical-align: middle;
				}
				span{
					color: rgba(255,255,255,0.8);
				}
			}
			.navbarList{
				ul{
					li{
						cursor: pointer;
						padding-left: 10px;
						padding-right: 10px;
						a{
							display: block;
							font-weight: 400;
							font-size: 14px;
							text-transform: capitalize;
							color: #666;
							-webkit-transition: all 0.3s ease 0s;
							-moz-transition: all 0.3s ease 0s;
							-o-transition: all 0.3s ease 0s;
							transition: all 0.3s ease 0s;
							border: transparent;
							padding: 13px 10px;
							border-radius: 18px;
							letter-spacing: .3px;
							&:hover{
								color: #e11e73 !important;
							}
						}
						&.active{
							a{
								color: #e11e73 !important;
							}
						}
					}
					li + li{
						margin-left: 0.5rem;
					}
				}
			}
		}
		.footers{
			ul{
				li{
					line-height: 28px;
					a{
						color: rgba(255,255,255,.5)!important;line-height: 1.2;
						&:hover{
							opacity: unset;
						}
					}
				}
			}
		}
		.footer{
			width: 100%;padding: 1.5rem 0;
		}
	}
</style>